import { progressApi as api } from "utilities/Axios";

export const getPointCloudImages = (id: number) => {
  const url = `/PointCloud/GetPointCloudImages?pointCloudId=${id}`;
  return api.get(url);
};

export const processDroneImages = () => {
  return api.get('/PointCloud/ProcessDroneImages');
};